document.addEventListener('DOMContentLoaded', function load() {
  class UtmCookie {
    constructor(options = {}) {
      this._cookieNamePrefix = "_uc_";
      this._domain = options.domain || window.location.hostname;
      this._sessionLength = options.sessionLength || 1;
      this._cookieExpiryDays = options.cookieExpiryDays || 365;
      this._additionalParams = options.additionalParams || [];
      this._utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

      this.writeInitialReferrer();
      this.writeLastReferrer();
      this.writeInitialLandingPageUrl();
      this.setCurrentSession();

      if (this.additionalParamsPresentInUrl()) this.writeAdditionalParams();
      if (this.utmPresentInUrl()) this.writeUtmCookieFromParams();
    }

    createCookie(name, value, days, path = "/", domain = this._domain, secure) {
      let date, expires = "";
      if (days) {
        date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      const domainStr = domain ? "; domain=" + domain : "";
      const secureStr = secure ? "; secure" : "";
      document.cookie = `${this._cookieNamePrefix}${name}=${encodeURIComponent(value)}${expires}; path=${path}${domainStr}${secureStr}`;
    }

    readCookie(name) {
      const nameEQ = `${this._cookieNamePrefix}${name}=`;
      const ca = document.cookie.split(';');
      for (let c of ca) {
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
      }
      return null;
    }

    eraseCookie(name) {
      this.createCookie(name, "", -1);
    }

    getParameterByName(name) {
      name = name.replace(/[\[\]]/g, "\\$&");
      const regex = new RegExp(`[?&]${name}=([^&#]*)`);
      const results = regex.exec(window.location.search);
      return results ? decodeURIComponent(results[1].replace(/\+/g, " ")) : "";
    }

    additionalParamsPresentInUrl() {
      return this._additionalParams.some(param => this.getParameterByName(param));
    }

    utmPresentInUrl() {
      return this._utmParams.some(param => this.getParameterByName(param));
    }

    writeCookie(name, value) {
      this.createCookie(name, value, this._cookieExpiryDays);
    }

    writeAdditionalParams() {
      this._additionalParams.forEach(param => {
        const value = this.getParameterByName(param);
        if (value) this.writeCookie(param, value);
      });
    }

    writeUtmCookieFromParams() {
      this._utmParams.forEach(param => {
        const value = this.getParameterByName(param);
        if (value) this.writeCookie(param, value);
      });
    }

    writeCookieOnce(name, value) {
      if (!this.readCookie(name)) this.writeCookie(name, value);
    }

    _sameDomainReferrer(referrer) {
      return referrer.includes(this._domain) || referrer.includes(window.location.hostname);
    }

    _isInvalidReferrer(referrer) {
      return !referrer || referrer === "";
    }

    writeInitialReferrer() {
      let value = document.referrer;
      if (this._isInvalidReferrer(value)) value = "direct";
      this.writeCookieOnce("referrer", value);
    }

    writeLastReferrer() {
      let value = document.referrer;
      if (!this._sameDomainReferrer(value)) {
        if (this._isInvalidReferrer(value)) value = "direct";
        this.writeCookie("last_referrer", value);
      }
    }

    writeInitialLandingPageUrl() {
      const value = this.cleanUrl();
      if (value) this.writeCookieOnce("initial_landing_page", value);
    }

    initialReferrer() {
      return this.readCookie("referrer");
    }

    lastReferrer() {
      return this.readCookie("last_referrer");
    }

    initialLandingPageUrl() {
      return this.readCookie("initial_landing_page");
    }

    incrementVisitCount() {
      const existing = parseInt(this.readCookie("visits"), 10);
      const newVal = isNaN(existing) ? 1 : existing + 1;
      this.writeCookie("visits", newVal);
    }

    visits() {
      return this.readCookie("visits");
    }

    setCurrentSession() {
      if (!this.readCookie("current_session")) {
        this.createCookie("current_session", "true", this._sessionLength / 24);
        this.incrementVisitCount();
      }
    }

    cleanUrl() {
      return window.location.origin + window.location.pathname + window.location.search.replace(/utm_[^&]+&?/g, '').replace(/&$/, '').replace(/^\?$/, '') + window.location.hash;
    }
  }

  class UtmForm {
    constructor(options = {}) {
      this._utmParamsMap = {
        utm_source: options.utm_source_field || "USOURCE",
        utm_medium: options.utm_medium_field || "UMEDIUM",
        utm_campaign: options.utm_campaign_field || "UCAMPAIGN",
        utm_content: options.utm_content_field || "UCONTENT",
        utm_term: options.utm_term_field || "UTERM"
      };

      this._additionalParamsMap = options.additional_params_map || {};
      this._initialReferrerField = options.initial_referrer_field || "IREFERRER";
      this._lastReferrerField = options.last_referrer_field || "LREFERRER";
      this._initialLandingPageField = options.initial_landing_page_field || "ILANDPAGE";
      this._visitsField = options.visits_field || "VISITS";
      this._addToForm = options.add_to_form || "all";
      this._formQuerySelector = options.form_query_selector || "form";

      this.utmCookie = new UtmCookie({
        domain: options.domain,
        sessionLength: options.sessionLength,
        cookieExpiryDays: options.cookieExpiryDays,
        additionalParams: Object.keys(this._additionalParamsMap)
      });

      if (this._addToForm !== "none") {
        this.addAllFields();
      }
    }

    addAllFields() {
      for (const param in this._utmParamsMap) {
        this.addFormElem(this._utmParamsMap[param], this.utmCookie.readCookie(param));
      }

      for (const param in this._additionalParamsMap) {
        this.addFormElem(this._additionalParamsMap[param], this.utmCookie.readCookie(param));
      }

      this.addFormElem(this._initialReferrerField, this.utmCookie.initialReferrer());
      this.addFormElem(this._lastReferrerField, this.utmCookie.lastReferrer());
      this.addFormElem(this._initialLandingPageField, this.utmCookie.initialLandingPageUrl());
      this.addFormElem(this._visitsField, this.utmCookie.visits());
    }

    addFormElem(fieldName, fieldValue) {
      if (!fieldValue) return;
      const forms = document.querySelectorAll(this._formQuerySelector);
      if (forms.length === 0) return;

      if (this._addToForm === "first") {
        const firstForm = forms[0];
        this.insertAfter(this.getFieldEl(fieldName, fieldValue), firstForm.lastChild);
      } else {
        forms.forEach(form => {
          this.insertAfter(this.getFieldEl(fieldName, fieldValue), form.lastChild);
        });
      }
    }

    getFieldEl(name, value) {
      const el = document.createElement("input");
      el.type = "hidden";
      el.name = name;
      el.value = value;
      return el;
    }

    insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
  }

  window._uf = window._uf || {};
  window.UtmForm = new UtmForm(window._uf);

  
  let form_id_clicked = undefined;
  let custom_redirect_url = "/pages/thankyou";

  const utmParams = {
    "utm_source": "USOURCE",
    "utm_medium": "UMEDIUM",
    "utm_campaign": "UCAMPAIGN",
    "utm_content": "UCONTENT",
    "utm_term": "UTERM"
  };

  const merge_vars = {};
  for (const param in utmParams) {
    const paramValue = window.UtmForm.utmCookie.readCookie(param);
    if (paramValue) {
      merge_vars[utmParams[param]] = paramValue;
    }
  }

  merge_vars['IREFERRER'] = (window.UtmForm.utmCookie.initialReferrer() || '').replace(/^https?%3A\/\//, '');
  merge_vars['LREFERRER'] = (window.UtmForm.utmCookie.lastReferrer() || '').replace(/^https?%3A\/\//, '');
  merge_vars['ILANDPAGE'] = (window.UtmForm.utmCookie.initialLandingPageUrl() || '').replace(/^https?%3A\/\//, '');
  merge_vars['VISITS'] = window.UtmForm.utmCookie.visits();

  document.addEventListener('datalayerPush', function(e) {
    let redirect = '/thankyou/';
    if (Array.isArray(window.dataLayer)) {
      for (const value of window.dataLayer) {
        if (value.event === 'success_subscription') {
          redirect = value.redirect;
          break;
        }
      }
    }
    window.location.href = redirect;
  });

  function showKlaviyoPhoneInput(input) {
    const wrapper = input.closest('.klaviyo-embed-form-wrapper');
    if (!wrapper) return;

    const rows = wrapper.querySelectorAll('form [data-testid="form-row"]');
    rows.forEach(row => {
      row.style.display = 'flex';
    });
  }

  const targetNodes = document.getElementsByClassName('klaviyo-embed-form-wrapper');
  const config = { attributes: true, childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      const button = mutation.target.querySelector('button');
      const formWrapper = mutation.target.closest('.klaviyo-embed-form-wrapper');

      if (button && formWrapper && !formWrapper.querySelector('form').id) {
        const form = formWrapper.querySelector('form');
        let id = formWrapper.id || 'footer_email_capture';
        form.id = id;

        setTimeout(() => {
          const emailInput = form.querySelector('input[type="email"]');
          const telInput = form.querySelector('input[type="tel"]');

          if (telInput) telInput.closest('[data-testid="form-row"]').style.display = "none";

          const paragraph = form.querySelector("p");
          if (paragraph) paragraph.closest('[data-testid="form-row"]').style.display = "none";

          ['paste', 'keyup', 'focus'].forEach(event => {
            emailInput.addEventListener(event, () => showKlaviyoPhoneInput(emailInput));
          });

          form.querySelector("button").addEventListener("click", () => {
            const old = document.getElementById('form_id_clicked');
            if (old) old.remove();

            const div = document.createElement('div');
            div.id = 'form_id_clicked';
            div.style.display = 'none';
            div.setAttribute('form_id_clicked', id);
            document.body.appendChild(div);

            form_id_clicked = id;
          });

          ['input[type="email"]', 'input[type="tel"]'].forEach(selector => {
            form.querySelectorAll(selector).forEach(input => {
              input.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                  const old = document.getElementById('form_id_clicked');
                  if (old) old.remove();

                  const div = document.createElement('div');
                  div.id = 'form_id_clicked';
                  div.style.display = 'none';
                  div.setAttribute('form_id_clicked', id);
                  document.body.appendChild(div);

                  form_id_clicked = id;
                }
              });
            });
          });

          if (emailInput.value !== '') {
            showKlaviyoPhoneInput(emailInput);
          }

          observer.disconnect();
        }, 300);
      }
    }
  };

  const observer = new MutationObserver(callback);
  for (let i = 0; i < targetNodes.length; i++) {
    observer.observe(targetNodes[i], config);
  }

  window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type === 'submit') {
      let formId = 'footer_email_capture';
      const tracker = document.getElementById('form_id_clicked');
      if (tracker) {
        formId = tracker.getAttribute('form_id_clicked');
      }
      emailToSend = document.correctedEmail || e.detail.metaData.$email;
      if (undefined != document.correctedEmail) {
        emailToSend = document.correctedEmail;
      }

      if (typeof dataLayer !== "undefined") {
        setTimeout(() => {
          dataLayer.push({
            'event': 'success_subscription',
            'formid': formId,
            'email': emailToSend,
            'fbLeadEventId': 'rf_lead_' + MD5(emailToSend),
            'redirect': custom_redirect_url + window.location.search
          });
        }, 100);
      }
    }
  });
});
